import React from 'react';

import type { FixedPrize, FixedPrizeDrawWonMPNotification } from '@swf/core/types/Notification';

import type { CardViewProps } from '../../config/NotificationTypes';
import { ActionType, FixedPrizeImageIconMap } from '../../enums';
import sharedStyles from '../../styles/shared.scss';
import Buttons from '../Buttons/Buttons';
import Header from '../Header/Header';
import IconActionList from '../IconActionList/IconActionList';
import Title from '../Title/Title';

import { TXTWCL_CongratulationsX_you_won_N0_pr_ELL } from './FixedPrizeDrawWon.messages.json';

interface CardDataProps {
  cardData: FixedPrizeDrawWonMPNotification;
}

const FixedPrizeDraw: React.FC<CardViewProps & CardDataProps> = ({
  cardData: {
    attributes: { prizes = [], winners = [] },
    attributes,
    notificationId,
    headerImageURL,
    type,
    title: drawName
  },
  viewConfig,
  onClickClose,
  onClickPrimaryAction,
  onClickSecondaryAction,
  onClickC2L
}) => {
  const formatTitleKey = () =>
    prizes.length > 1
      ? {
          tag: TXTWCL_CongratulationsX_you_won_N0_pr_ELL,
          values: { 0: 'myPrizes', 1: 'drawName' }
        }
      : viewConfig.title;

  const prizesToListData = (p: FixedPrize[]) =>
    p.map(({ imageURL, prizeName, prizeType, launchURL }) => {
      const response = {
        icon:
          imageURL ||
          FixedPrizeImageIconMap[prizeType as unknown as keyof typeof FixedPrizeImageIconMap],
        text: prizeName
      };
      return {
        ...response,
        action: () => {
          const formattedLaunchURL = launchURL.replace('{c2l_handler}://', '/');
          const launchData = { data: { c2l: formattedLaunchURL } };
          onClickC2L(launchData);
        }
      };
    });

  let buttonList = viewConfig.actions;
  if (winners.length === 0 && buttonList) {
    buttonList = buttonList.filter((a) => a.actionType !== ActionType.Secondary);
  }
  return (
    <>
      <Header
        showCloseIcon={viewConfig.showCloseIcon}
        headerImageURL={headerImageURL}
        defaultHeaderImageURL={viewConfig.defaultHeaderImageURL}
        onClickClose={onClickClose}
      />
      <section className={sharedStyles.notificationBody}>
        <Title
          titleKey={formatTitleKey()}
          attributes={{ ...attributes, myPrizes: prizes.length, drawName }}
        />
        {/* TODO: fix types
        // @ts-ignore wrong prop type in IconActionList*/}
        <IconActionList dataList={prizesToListData(prizes)} />

        <Buttons
          actionList={buttonList}
          notificationType={type}
          attributes={attributes}
          notificationId={notificationId}
          onClickPrimaryAction={onClickPrimaryAction}
          onClickSecondaryAction={onClickSecondaryAction}
        />
      </section>
    </>
  );
};

export default FixedPrizeDraw;
